import { ReactElement } from 'react';
import { parseZone } from 'moment';
import { useNavigateWithUTMs } from '../../hooks/useNavigateWithUTMs';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { useAuth } from '../../contexts/AuthContext';
import styles from './ProductDisplayPage.module.scss';

type Props = {
  pageTitle: string,
}

export function Breadcrumb({
  pageTitle,
}: Props): ReactElement {
  const { isLoggedIn } = useAuth();
  const {
    menu,
    onSelectMenu,
    cart,
  } = useMenuWithCart();
  const weekOfDate = menu?.deliveryOn ? parseZone(menu?.deliveryOn)
    .format('MMMM DD') : '';

  const { navigate } = useNavigateWithUTMs();
  const breadcrumbUrl = isLoggedIn ? '/upcoming-menus' : '/shop';
  const breadcrumbText = isLoggedIn ? `${weekOfDate} Menu Week` : 'Shop the Menu';
  const handleLoggedInBreadcrumbClick = () => {
    if (isLoggedIn && menu && cart) {
      onSelectMenu(menu?.id, cart?.id);
    }
    navigate(breadcrumbUrl);
  };

  return (
    <div className={styles.breadcrumbs}>
      <a
        className={styles.week_of}
        role="button"
        onClick={handleLoggedInBreadcrumbClick}
      >
        {breadcrumbText}
      </a>
      <span className={styles.separator}>/</span>
      {pageTitle}
    </div>
  );
}
